var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"treeDiv",staticClass:"tree-container"},[_c('el-tree',_vm._g(_vm._b({ref:"tree",staticClass:"tree",attrs:{"indent":0},scopedSlots:_vm._u([{key:"default",fn:function({ node }){return [_c('span',{attrs:{"title":node.label}},[_vm._v(_vm._s(node.label))])]}}])},'el-tree',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }